import { QueryClientProvider } from '@tanstack/react-query';
import { type ReactElement, type ReactNode, useState } from 'react';

import { ErrorBoundary } from './ErrorBoundary.js';
import { createQueryClient } from './query-client.js';

interface AppProvidersProps {
    children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps): ReactElement {
    const [queryClient] = useState(createQueryClient);
    return (
        <ErrorBoundary>
            <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
        </ErrorBoundary>
    );
}
